import {useEffect, useState} from "react";
import {getCheckoutDetails} from "../api/apiClient";

export const useCheckoutDetails = (eventUuid, productUuid, coupon, paymentMethod, reloadTrigger) => {
    const [event, setEvent] = useState([]);
    const [product, setProduct] = useState([]);
    const [productActivationDate, setProductActivationDate] = useState([]);
    const [productExpirationDate, setProductExpirationDate] = useState([]);
    const [bruttoPriceWithCoupon, setBruttoPriceWithCoupon] = useState([]);
    const [couponCode, setCouponCode] = useState(null);
    const [couponErrorMessage, setCouponErrorMessage] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const checkoutDetails = getCheckoutDetails(eventUuid, productUuid, coupon, paymentMethod, abortController.signal);

        checkoutDetails
            .then(
                (data) => {
                    const event = data.event;
                    const product = data.product;
                    const productActivationDate = data.productActivationDate;
                    const productExpirationDate = data.productExpirationDate;
                    const bruttoPriceWithCoupon = data.bruttoPriceWithCoupon;
                    const couponCode = data.couponCode;
                    const couponErrorMessage = data.couponErrorMessage;

                    setEvent(event)
                    setProduct(product)
                    setProductActivationDate(productActivationDate)
                    setProductExpirationDate(productExpirationDate)
                    setBruttoPriceWithCoupon(bruttoPriceWithCoupon)
                    setCouponCode(couponCode)
                    setCouponErrorMessage(couponErrorMessage);
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [eventUuid, productUuid, coupon, paymentMethod, reloadTrigger]);

    return {event : event, product : product, productActivationDate : productActivationDate, productExpirationDate : productExpirationDate, bruttoPriceWithCoupon: bruttoPriceWithCoupon, couponCode : couponCode, couponErrorMessage : couponErrorMessage};
};